import { LabeledCheckbox } from "@core/components/forms/LabeledCheckbox";
import { LabeledInput } from "@core/components/forms/LabeledInput";
import { LabeledSelect } from "@core/components/forms/LabeledSelect";
import { useMedicalConfig } from "@phoenix/med/hooks/useMedicalConfig";
import { t } from "i18next";
import React from "react";
import { useFormContext } from "react-hook-form";

export const CustomCompoundFields = () => {
  const [selectedTherapy, setSelectedTherapy] = React.useState<string>("");
  const [otherMedicationSelected, setOtherMedicationSelected] = React.useState<boolean>(false);
  const [allowSubstitutions, setAllowSubstitutions] = React.useState<boolean>(false);
  const methods = useFormContext();
  const medConfig = useMedicalConfig();
  return (
    <>
    <LabeledSelect
      disabled={!medConfig.CustomCompoundTherapies?.length}
      label={t("ui.Therapy", "Therapy")}
      {...methods.register("Therapy.Value", {
        required: medConfig.CustomCompoundTherapies && medConfig.CustomCompoundTherapies?.length > 0,
        validate: (value: string) => {
          if (medConfig.CustomCompoundTherapies && medConfig.CustomCompoundTherapies?.length > 0 && !value) {
            return "Please select a therapy.";
          }
        }
      })}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedTherapy(e.currentTarget.value);
      }}
      errors={methods.formState.errors}>
      <option value="">{t("ui.Select", "Select")}</option>
      {medConfig.CustomCompoundTherapies?.map(r => <option key={r.TherapyName} value={r.TherapyName}>{r.TherapyName}</option>)}
    </LabeledSelect>
    <LabeledSelect
      disabled={!medConfig.CustomCompoundTherapies?.length || !selectedTherapy}
      label={t("ui.Medication", "Medication")}
      {...methods.register("Medication.Value", {
        required: medConfig.CustomCompoundTherapies && medConfig.CustomCompoundTherapies?.length > 0,
        validate: (value: any) => {
          if (medConfig.CustomCompoundTherapies && medConfig.CustomCompoundTherapies?.length > 0 && !value) {
            return "Please select a medication.";
          }
        }
      })}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
        setOtherMedicationSelected(e.currentTarget.value === "Other");
        methods.setValue("Medication.Value", e.currentTarget.value, { shouldValidate: true });
      }}
      errors={methods.formState.errors}>
      <option value="">{t("ui.Select", "Select")}</option>
      {medConfig.CustomCompoundTherapies?.find(x => x.TherapyName === selectedTherapy)?.Medications?.map(med => <option key={med} value={med}>{med}</option>)}
      {selectedTherapy && <option value="Other">{t("ui.Other", "Other")}</option>}
    </LabeledSelect>
    {otherMedicationSelected
      ? (
        <LabeledInput
          label={t("ui.MedicationName", "Medication name")}
          {...methods.register("MedicationName.Value", {
            required: otherMedicationSelected
          })}
          errors={methods.formState.errors} />
      )
      : null}
    <LabeledCheckbox
      label="Allow Substitutions"
      {...methods.register("AllowSubstitutions.Value")}
      checked={allowSubstitutions}
      defaultChecked={allowSubstitutions}
      onClick={(e: React.MouseEvent) => {
        const target = e.target as HTMLInputElement;
        setAllowSubstitutions(x => {
          methods.setValue("AllowSubstitutions.Value", (!x).toString(), { shouldValidate: true });
          return !x;
        });
      }}
      
    />
  </>
  );
}